var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".spinner_l9ve{animation:spinner_rcyq 1.2s cubic-bezier(0.52,.6,.25,.99) infinite}.spinner_cMYp{animation-delay:.4s}.spinner_gHR3{animation-delay:.8s}@keyframes spinner_rcyq{0%{transform:translate(12px,12px) scale(0);opacity:1}100%{transform:translate(0,0) scale(1);opacity:0}}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "spinner_l9ve",
    d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z",
    transform: "translate(12, 12) scale(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "spinner_l9ve spinner_cMYp",
    d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z",
    transform: "translate(12, 12) scale(0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "spinner_l9ve spinner_gHR3",
    d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,20a9,9,0,1,1,9-9A9,9,0,0,1,12,21Z",
    transform: "translate(12, 12) scale(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderRound);
export default __webpack_public_path__ + "static/media/loader-round.7ed82b6e4d92c76877f40201b60c0fee.svg";
export { ForwardRef as ReactComponent };